// extracted by mini-css-extract-plugin
export default {"page":"pQ","heading":"qQ","subheading":"rQ","flavorbox":"sQ","inner":"tQ","image":"uQ","label":"vQ","flavorselect":"wQ","arrow":"xQ","flavorswrap":"yQ","flavorsheader":"zQ","flavorsnav":"AQ","flavorsinner":"BQ","cancelbtn":"CQ","flavorsbottom":"EQ","retakebtn":"FQ","continueBtn":"GQ","drawerinner":"HQ","videowrap":"IQ","flavorsbottomnav":"JQ"};
    if(module.hot) {
      // 1713969935925
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  